var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDesign(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 368,
    viewBox: "0 0 512 368",
    fill: "#ffffff",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 356L16 11H181V161H46L46 41H151V56H61L61 146H136V86H91V116H76V71H151V146H166L166 26H31L31 356H16Z",
    fill: "#fffffff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M46 356L46 176H181V356H106V326H91V356H76V311H121V341H166L166 191H61L61 356H46Z",
    fill: "#fffffff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M136 326H151L151 206H76L76 296H91L91 221H136L136 326Z",
    fill: "#ffffff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M196 356V251H286V326H226V281H241V311H271V266H211V341H301V176H316V356H196Z",
    fill: "#fffffff"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M316 161V41H226V131H271V86H256V116H241V56H301V146H211V26H331V206H451V281H406V236H436V221H391V296H466V191H346V11H196V161H316Z",
    fill: "#fffffff"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M331 221H376V311H481V176H361V11H496V146H451V56H406V71H436V131H421V86H391V41H466V131H481V26H376V161H496V326H361V236H346V341H496V356H331V221Z",
    fill: "#fffffff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDesign);
export default __webpack_public_path__ + "static/media/design.43a943e40d3ec2aafc81f9f9145b66f5.svg";
export { ForwardRef as ReactComponent };